// Google Analytics 4 utility functions
// Only loads GA4 when user has consented to analytics cookies

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Check if user has consented to analytics cookies
export const hasAnalyticsConsent = () => {
  try {
    const consent = localStorage.getItem('cookie-consent');
    if (consent) {
      const parsed = JSON.parse(consent);
      return parsed.analytics === true;
    }
  } catch (e) {
    console.error('Error checking analytics consent:', e);
  }
  return false;
};

// Initialize Google Analytics
export const initGA = () => {
  if (!GA_MEASUREMENT_ID) {
    console.warn('Google Analytics Measurement ID not configured');
    return;
  }

  if (!hasAnalyticsConsent()) {
    console.log('Analytics consent not given, GA not loaded');
    return;
  }

  // Check if already loaded
  if (window.gtag) {
    console.log('GA already initialized');
    return;
  }

  // Load the GA4 script
  const script = document.createElement('script');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  window.gtag = function() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, {
    anonymize_ip: true, // GDPR compliance - anonymize IP addresses
    cookie_flags: 'SameSite=None;Secure',
  });

  console.log('Google Analytics initialized');
};

// Track page views
export const trackPageView = (path) => {
  if (!hasAnalyticsConsent() || !window.gtag || !GA_MEASUREMENT_ID) return;
  
  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
};

// Track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (!hasAnalyticsConsent() || !window.gtag) return;
  
  window.gtag('event', eventName, eventParams);
};

// Remove GA cookies when consent is revoked
export const removeGACookies = () => {
  // GA4 cookie names
  const gaCookies = ['_ga', '_ga_*', '_gid', '_gat'];
  
  gaCookies.forEach(cookieName => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  });
  
  // Remove from all possible domains
  const domain = window.location.hostname;
  const domainParts = domain.split('.');
  
  for (let i = 0; i < domainParts.length; i++) {
    const cookieDomain = domainParts.slice(i).join('.');
    gaCookies.forEach(cookieName => {
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${cookieDomain}`;
    });
  }
};
